// extracted by mini-css-extract-plugin
export default {"header-container":"header_header-container__hsGdi","header-content":"header_header-content__s5rOm"};